import { useState } from 'react';
import { Link } from 'react-router';
import { api, errorText } from '../lib/api';
import { speak } from '../lib/format';
import type { StepProps } from './context';

export function Expressions({ detail, complete, playSegment, loggedIn }: StepProps) {
  const [saved, setSaved] = useState<Record<string, string>>({});
  const bySeg = new Map(detail.segments.map((s) => [s.id, s]));
  const list = detail.lesson.expressions;
  const save = async (id: string, text: string, meaning: string | null, segmentId: string) => {
    try {
      await api('/vocab', { method: 'POST', json: { kind: 'expression', surface: text, meaning: meaning ?? undefined, segmentId } });
      setSaved((s) => ({ ...s, [id]: '已收藏' }));
    } catch (e) {
      setSaved((s) => ({ ...s, [id]: errorText(e) }));
    }
  };
  if (!list.length) {
    return (
      <div className="step-body">
        <p className="muted">这一集还没有整理核心表达。精听时把想学的表达加入表达本即可。</p>
        <button className="primary" onClick={() => complete('expressions')}>
          下一步
        </button>
      </div>
    );
  }
  return (
    <div className="step-body">
      {list.map((x) => {
        const seg = x.segmentId ? bySeg.get(x.segmentId) : undefined;
        return (
          <article key={x.id} className="expr-card">
            <header className="row spread">
              <h4>{x.text}</h4>
              <span className="meaning">{x.meaning}</span>
            </header>
            {seg && (
              <div className="context-box" onClick={() => playSegment(seg)}>
                <span className="play-hint">▶</span> {seg.en}
                {seg.zh && <div className="zh">{seg.zh}</div>}
              </div>
            )}
            {x.explanation && <p className="muted">{x.explanation}</p>}
            {x.examples?.map((ex, k) => (
              <p key={k} className="example" onClick={() => speak(ex.en)}>
                {ex.en}
                <br />
                <small className="muted">{ex.zh}</small>
              </p>
            ))}
            <div className="row">
              {seg &&
                (loggedIn ? (
                  <button className="small" disabled={saved[x.id] === '已收藏'} onClick={() => save(x.id, x.text, x.meaning, seg.id)}>
                    {saved[x.id] === '已收藏' ? '✓ 已收藏' : '收藏到表达本'}
                  </button>
                ) : (
                  <Link className="button small" to="/me">
                    登录后收藏
                  </Link>
                ))}
              {saved[x.id] && saved[x.id] !== '已收藏' && <small className="status">{saved[x.id]}</small>}
            </div>
          </article>
        );
      })}
      <small className="muted">例句为 AI 辅助编写，点击可朗读；原句来自本集原声。</small>
      <button className="primary" onClick={() => complete('expressions')}>
        完成表达学习
      </button>
    </div>
  );
}
